import React, { Component, Fragment } from "react";
import {matchPath,withRouter} from "react-router-dom";
import { connect } from "react-redux";
import AppContext from "app/appContext";
import GullLayout from "app/GullLayout/GullLayout";
import { flatMap } from "lodash";
import CAN from "../casl/Can";
import * as _ from "lodash";
import {Loading} from "../../@gull";
import SessionTimeout from "./SessionTimeout";

class AuthGuard extends Component {
  constructor(props, context) {
    super(props);
    let { routes } = context;

    this.state = {
      authenticated: true,
      routes
    };
  }

  componentDidMount() {
    this.setState({
      routes: flatMap(this.state.routes, item => {
        if (item.routes) {
          return [...item.routes];
        }
        return [item];
      })
    });

    if (!this.state.authenticated) {
      this.redirectRoute(this.props);
    }
  }

  componentDidUpdate() {
    if (!this.state.authenticated) {
      this.redirectRoute(this.props);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.authenticated !== this.state.authenticated || !_.isEmpty(this.props.user);
  }

  static getDerivedStateFromProps(props, state) {
    const { location, user } = props;
    const { pathname } = location;

    const matched = state.routes.find(r => {
      const routeMatchPath = matchPath(pathname, r.path)
      return pathname === routeMatchPath?.url;
    });

    // const authenticated =
    //   matched && matched.auth && matched.auth.length
    //     ? matched.auth.includes(user.role)
    //     : true;

    let authenticated = true;
    if (matched && matched.key && matched.key.length && !user.initialLoading) {
      let per = matched.key.split("_");
      authenticated = CAN(per[0], per[1]);
    }

    return {
      authenticated
    };
  }

  redirectRoute(props) {
    const { location, history } = props;
    const { pathname } = location;

    history.push({
      pathname: "/session/403",
      state: { redirectUrl: pathname }
    });
  }

  render() {
    let { route, user } = this.props;
    const { authenticated } = this.state;

    if (user.initialLoading) {
      return <Loading/>;
    }
    return authenticated ? (
      <Fragment>
        <SessionTimeout/>
        <GullLayout route={route}></GullLayout>
      </Fragment>
    ) : <Loading/>;
  }
}

AuthGuard.contextType = AppContext;

const mapStateToProps = state => ({
  user: state.user
});

export default withRouter(connect(mapStateToProps)(AuthGuard));
